export const preferenceOptionsEnum = {
    email: { label: 'Email', value: 'EMAIL' },
    sms: { label: 'SMS', value: 'SMS' },
    whatsapp: { label: 'WhatsApp', value: 'WHATSAPP' },
  };

  